/** @format */

(function ($) {
    "use strict";

    $(".accessibility-footer-link").on("click", function (e) {
        e.preventDefault();
        // dirty hack until we get the "powered by ihouse"
        // footer rendering with react.
        window.store.dispatch({
            type: "ACCESSIBILITY_SETTINGS_MENU_TOGGLE",
            payload: {},
        });
    });
})(window.jQuery);
